import React from 'react';

import AfterDoc from '@/components/ui/AfterDoc';
import { PRODUCT } from '@/consts';
import { CONSULTANTS } from '@/features/v2/consultants';

import { useLingui } from '@lingui/react';

const ThankYouNotQualifySettlement = () => {
  const { i18n } = useLingui();

  return (
    <AfterDoc
      consultant={CONSULTANTS.MARTA_ASSISTANT}
      thankYouMessage={i18n.t(
        'Niestety, nie możemy podjąć dalszych działań w Twojej sprawie'
      )}
      withButton
      productId={PRODUCT.HOUSE_HOLD}
    >
      <div>
        <p className="body">
          {i18n.t(
            'Ugoda, którą zawarto, oznacza rezygnację z dalszych roszczeń w sprawie szkody na nieruchomości i z tego powodu nie możemy podjąć kolejnych działań. Rozumiemy, że może to budzić pytania lub wątpliwości, dlatego jeśli potrzebujesz dodatkowych informacji, jesteśmy tutaj, aby pomóc.'
          )}
        </p>
      </div>
      <p className="body font-semibold">
        {i18n.t('W przypadku pytań zapraszamy do kontaktu.')}
      </p>
    </AfterDoc>
  );
};

export default ThankYouNotQualifySettlement;
